<template>
  <div class="container-fluid">
    <loading
      v-if="!listIframeSrcNotLoading.includes(iframeSrc)"
      :active.sync="isLoading"
      :can-cancel="false"
      :is-full-page="true"
    />
    <iframe
      :src="iframeSrc"
      frameborder="0"
      :style="iframeStyle"
      @load="load"
      v-show="!isLoading"
    />
  </div>
</template>

<script>
import Loading from 'vue-loading-overlay'
import { defaultHeaderTotalHeight } from '../../assets/style/_variables.scss'
import AppConstants from '../../constants/app.constants'

export default {
  components: {
    Loading
  },
  props: {
    iframeSrc: {
      type: String,
      required: true
    },
    iframeStyle: {
      type: Object,
      default: () => ({
        position: 'relative',
        width: '100%',
        height: `calc(100vh - ${defaultHeaderTotalHeight}px)`
      })
    }
  },
  data() {
    return {
      isLoading: true,
      listIframeSrcNotLoading: [
        AppConstants.DEVICE_REGISTRATION_MGMT_EMBEDDED_URL
      ]
    }
  },
  methods: {
    /**
    * iframeの読み込み完了時に呼び出される関数。
    */
    load() {
      this.isLoading = false
    }
  }
}
</script>

<style lang="scss" scoped>
.container-fluid {
  padding-left: 0 !important;
  padding-right: 0 !important;
}
</style>



// WEBPACK FOOTER //
// src/components/custom-components/Embedded.vue